export default {
  loading: {
    type: Boolean,
  },
  noData: {
    type: Boolean,
  },
  determinate: {
    type: Boolean,
  },
  test: {
    type: Boolean,
  },
};
